import { render, staticRenderFns } from "./DermaVisitaEdit.vue?vue&type=template&id=1c5ec6fa"
import script from "./DermaVisitaEdit.vue?vue&type=script&lang=js"
export * from "./DermaVisitaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports